<!--- Componente Paletizado con Lectura de cajas ---->
<!---
Descripción del componente y comportamiento:
---------------------------
-

Eventos escuchados por el componente:
-----------------------
-

Eventos generados por el componente:
-----------------------
-  XXXXXXX ->
--->

<template>
  <div class="main-PCLecturaEnvasesPale">
    <!-- PALE: <pre> {{ articuloNumeroSerie }}</pre> -->
    <!-- Escanear Codigo Lectura cajas -->

    <!--
    <UCCodeScanner
      v-if="mostrarBotonLecturaCajas && !asignacionRegistroTrabajadores"
      ref="UCCodeScanner"
      text-button="Escanear Caja"
      :allow-manual-code-entry="true"
      :fabButtonShow="false"
      :continuous-bar-code-reading="configuracionLecturaCajas.LecturaContinuaCodigosBarras || configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual"
      :autofocus-on-input="configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual"
      cabecera-popup="Lectura De Caja"
      @code-reading="EventoLecturaDeCodigoDeBarrasCaja"
    />

    <UCCodeScanner
      v-if="mostrarBotonLecturaCajas && asignacionRegistroTrabajadores"
      ref="UCCodeScannerConRegistros"
      text-button="Escanear Caja"
      :fabButtonShow="false"
      :allow-manual-code-entry="true"
      :autofocus-on-input="configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual"
      cabecera-popup="Lectura De Caja"
      @code-reading="EventoLecturaDeCodigoDeBarrasCaja"
    />

     Escanear Codigo trabajador --
    <UCCodeScanner
      v-if="mostrarBotonLecturaCajas && asignacionRegistroTrabajadores"
      ref="UCCodeScannerRegistroActividadContinua"
      text-button="Escanear"
      :fab-button-show="false"
      :allow-manual-code-entry="true"
      :autofocus-on-input="configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual"
      :cabecera-popup="$t('production.common.activitiesRecord')"
      :sub-title="$t('production.common.boxIdentifier')"
      :sub-title-value="articuloElaboradoSeleccionado != null ? articuloElaboradoSeleccionado.CodigoBarras.toString() : ''"
      @code-reading="EventoLecturaDeCodigoDeBarrasRegistroActividad"
    />
    -->
    <!--
<pre> {{ configuracionLecturaCajas.OrientacionCamaraLecturaCodigos }}</pre>
<pre> {{ configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual }} </pre>

    -->

    <!-- Puntos de paletizado que trabajan con asignación de registros de actividad en cada una de las cajas leidas -->
    <PCLectorArticuloElaborado
      v-if="!asignacionRegistroTrabajadores"
      ref="componentPCLectorArticuloElaborado"
      :continuous-bar-code-reading="configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual"
      :orientation-scan="configuracionLecturaCajas.OrientacionCamaraLecturaCodigos"
      @code-reading-articulo-elaborado="EventoLecturaDeCodigoDeBarrasCaja_NEW"
    />

    <PCLectorArticuloElaboradoYActividad
      v-if="asignacionRegistroTrabajadores"
      ref="componentPCLectorArticuloElaboradoYActividad"
      :numero-lecturas-de-actividad-por-caja="cantidadLecturasContinuas"
      :orientation-scan="configuracionLecturaCajas.OrientacionCamaraLecturaCodigos"
      :continuous-bar-code-reading="configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual"
      @code-reading-articulo-elaborado="EventoLecturaDeCodigoDeBarrasCaja_NEW"
      @code-reading-registro-actividad="EventoLecturaDeCodigoDeBarrasRegistroActividad_NEW"
    />

    <!-- v-if="configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual && asignacionRegistroTrabajadores" -->
    <!-- Listado Cajas asociadas al Palé -->
    <div
      v-if="objAnsSeleccionado != null"
      class="div-cabeceraTituloCajasAsociadas"
    >
      <span> {{ $t('production.assignBoxesPallet.associatedBoxes') }} </span>
      <span v-if="lstArticulosElaboradosAns != null">
        ({{ lstArticulosElaboradosAns.length }} <span v-if="pedidoSeleccionado != null"> {{ $t('common.of') }} {{ totalEnvases }}</span>)
      </span>
    </div>
    <div>
      <div class="div-listado">
        <UCPreload :show="preloader" />
        <div
          v-for="articuloElaborado in lstArticulosElaboradosAns.slice().reverse()"
          :key="articuloElaborado.Id"
          class="div-registroPale"
        >
          <f7-row>
            <f7-col width="65">
              <f7-row>
                <f7-col width="100">
                  <div class="display-flex">
                    <span
                      :class="articuloElaborado.Id !== 0 || (articuloElaborado.sinSincronizar !== undefined && articuloElaborado.sinSincronizar) ? 'span-texto-azulOscuro-22-500' : 'span-texto-rojoError-22-500'"
                    >{{ articuloElaborado.CodigoBarras }}</span>
                    <div
                      v-if="asignacionRegistroTrabajadores && articuloElaborado.ArticuloRegistro.length < 1"
                      class="margin-left-half"
                    >
                      <img
                        src="@/static/icons/warninCajas.svg"
                        alt="iconWarning"
                        width="14px"
                      >
                    </div>
                    <div
                      v-if="ErrorRegistro(articuloElaborado)"
                      class="margin-left-half"
                    >
                      <img
                        src="@/static/icons/ic_warning.svg"
                        alt="iconWarning"
                        width="14px"
                      >
                    </div>
                  </div>
                </f7-col>
              </f7-row>
              <f7-row>
                <f7-col width="100">
                  <span
                    v-if="articuloElaborado.Producto != null"
                    class="span-texto-grisAzul-14-400"
                  >{{ articuloElaborado.Producto.Nombre }}</span>
                  <span
                    v-if="articuloElaborado.Id === 0"
                    class="div-registro__sub-title"
                  >{{ articuloElaborado.mensajeError }}</span>
                </f7-col>
              </f7-row>
            </f7-col>
            <f7-col
              width="20"
              class=""
            />
            <f7-col
              width="15"
              class=""
            >
              <div class="display-flex justify-content-end">
                <div
                  v-if="asignacionRegistroTrabajadores"
                  class="btn-base-gris-1 seleccionable"
                  @click="EditarRegistroActividadArticuloElaborado(articuloElaborado)"
                >
                  <img
                    src="@/static/icons/Edit.svg"
                    alt="iconEdit"
                    width="50px"
                  >
                </div>
                <div
                  v-if="articuloElaborado.Id !== 0"
                  class="btn-base-rojo-1 seleccionable"
                  @click="SolicitarEliminarArticuloElaborado(articuloElaborado)"
                >
                  <img
                    src="@/static/icons/ic_trash_white.svg"
                    alt="iconDelete"
                    width="14px"
                  >
                </div>
                <div
                  v-else
                  class="btn-base-rojo-1 seleccionable"
                  @click="SolicitarEliminarArticuloElaboradoLocal(articuloElaborado)"
                >
                  <img
                    src="@/static/icons/ic_trash_white.svg"
                    alt="iconDelete"
                    width="14px"
                  >
                </div>
              </div>
            </f7-col>
          </f7-row>
        </div> <!-- Fin registro -->
      </div>
    </div>

    <!-- Action Confirmación Eliminar Palé -->
    <UCConfirmation ref="componenteConfirmacionEliminarPale" />
  </div>
</template>

<script>
import { useParamRef } from '@erpagroapp/params';
import { Log } from '@/js/common/HIDebuggingSupport';
import UCPreload from '@/components/common/UCPreload.vue';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import { sleep } from '@/js/utils/sleep';
import { callExecuteSPERP } from '@/js/services/APIErp';
import { notifyReadingError } from '@/js/utils/notifyReadingError';
import PCLectorArticuloElaborado from './PCLectorArticuloElaborado.vue';
import PCLectorArticuloElaboradoYActividad from './PCLectorArticuloElaboradoYActividad.vue';

export default {
  name: 'PCLecturaEnvasesPale',
  components: {
    UCPreload,
    UCConfirmation,
    PCLectorArticuloElaborado,
    PCLectorArticuloElaboradoYActividad,
  },
  props: {
    cantidadLecturasContinuas: { type: Number, default: 0 },
    pedidoSeleccionado: {
      type: Object,
      default: null,
    },
    totalEnvases: {
      type: Number,
      default: 0,
    },
    articuloNumeroSerie: {
      type: Object,
      default: null,
    },
    configuracionLecturaCajas: {
      type: Object,
      required: true,
    },
    configuracionLecturaRegistroAct: {
      type: Object,
      default: null,
    },
    asignacionRegistroTrabajadores: { type: Boolean, default: false },
    comprobarConfeccionCaja: { type: Boolean, default: false },
  },

  emits: [
    'pendientes-Sinc',
    'editarActividadEnvase',
  ],

  data() {
    return {
      objAnsSeleccionado: null,
      lstArticulosElaboradosAns: [],
      preloader: false,
      articuloElaboradoSeleccionado: null,
      // actionConfirmarEliminarArticuloElaborado: false,
      lstArtElaboradosPenSinc: [], // Lista para guardar articulos elaborados y registro actividades al finalizar las lecutras
      comprobarConfeccionCajaEnMovilidad: useParamRef('ComprobarConfeccionCajaEnMovilidad'),
      lstRegistrosActividad: [],
    };
  },
  computed: {
    /*
    mostrarBotonLecturaCajas() {
      return this.objAnsSeleccionado != null;
    },
    */
  },
  watch: {
    articuloNumeroSerie(val) {
      if (val != null) {
        this.PaleEstablecido(val);
        if (this.configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual && this.asignacionRegistroTrabajadores) {
          this.$refs.componentPCLectorArticuloElaboradoYActividad.focus();
        }
        if (this.configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual && !this.asignacionRegistroTrabajadores) {
          this.$refs.componentPCLectorArticuloElaborado.focus();
        }
        this.$emit('pendientes-Sinc', this.lstArtElaboradosPenSinc);
      } else {
        this.RestablecerFrm();
      }
    },
  },

  methods: {
    /**
     * @public
     * @returns {void}
     */
    RestablecerFrm() {
      this.objAnsSeleccionado = null;
      this.lstArticulosElaboradosAns = [];
      if (this.asignacionRegistroTrabajadores) {
        this.$refs.componentPCLectorArticuloElaboradoYActividad.reset();
      } else {
        this.$refs.componentPCLectorArticuloElaborado.reset();
      }
    },
    RestablecerArticulosLocales() {
      Log(this, this.RestablecerArticulosLocales.name);
      this.lstArtElaboradosPenSinc = [];
      this.$emit('pendientes-Sinc', this.lstArtElaboradosPenSinc);
    },

    /**
     * @public
     * @returns {Promise<void>}
     */
    async GuardarCajasPendientes() {
      Log(this, this.GuardarCajasPendientes.name);
      this.preloader = true;
      const result = await this.Conexion_AsociarActividadesRegistrosArticulosElaborados(this.objAnsSeleccionado, this.lstArtElaboradosPenSinc);

      if ('errorSinTag' in result) {
        this.preloader = false;
        return;
      }
      this.lstArtElaboradosPenSinc = [];
      const articulosConError = result.ERROR_AE;
      const registrosActividadConError = result.ERROR_RA;
      this.RestablecerFrm();
      await this.PaleEstablecido(this.articuloNumeroSerie);
      articulosConError.forEach((element) => {
        const articuloError = element.tag;
        articuloError.mensajeError = element.mensaje;
        this.lstArticulosElaboradosAns.push(articuloError);
      });

      registrosActividadConError.forEach((registroError) => {
        this.lstArticulosElaboradosAns.forEach((element) => {
          const articuloE = element;
          if (articuloE.CodigoBarras === registroError.tag.ArticuloElaborado.CodigoBarras) {
            const registro = registroError.tag;
            registro.mensajeError = registroError.mensaje;
            articuloE.ArticuloRegistro.push(registro);
          }
        });
      });

      this.lstArticulosElaboradosAns.forEach((articuloElaborado) => {
        if (articuloElaborado.Id === 0) {
          this.lstArtElaboradosPenSinc.push(articuloElaborado);
          return;
        }
        let anadido = false;
        articuloElaborado.ArticuloRegistro.forEach((registro) => {
          if (!anadido && registro.Id === 0) {
            anadido = true;
            this.lstArtElaboradosPenSinc.push(articuloElaborado);
          }
        });
      });
      this.$emit('pendientes-Sinc', this.lstArtElaboradosPenSinc);

      // Ordenar la lista para mostrar los errores al principio
      const objetosConIdCero = this.lstArticulosElaboradosAns.filter((objeto) => objeto.Id === 0 || (objeto.ArticuloRegistro.some((registro) => registro.Id === 0)));
      const objetosConId = this.lstArticulosElaboradosAns.filter((objeto) => {
        if (objeto.Id !== 0) {
          return objeto.ArticuloRegistro.every((registro) => registro.Id !== 0);
        }
        return false;
      });
      this.lstArticulosElaboradosAns = [];
      this.lstArticulosElaboradosAns = objetosConIdCero.concat(objetosConId);
      this.preloader = false;
    },
    /*
    async EventoLecturaDeCodigoDeBarrasCaja(codigoBarras) {
      Log(this, this.EventoLecturaDeCodigoDeBarrasCaja.name);
      if (!this.asignacionRegistroTrabajadores) {
        this.lstArticulosElaboradosAns = [];
      }
      if (!this.asignacionRegistroTrabajadores) {
        this.preloader = true;
      }
      this.codigoDeBarrasParaBusqueda = codigoBarras;
      if (codigoBarras.length > 13) {
        // Obtener los últimos 20 dígitos
        const ultimos20Digitos = codigoBarras.slice(-20);
        this.codigoDeBarrasParaBusqueda = ultimos20Digitos;
      }
      if (this.asignacionRegistroTrabajadores) {
        const prefijoCaja = this.codigoDeBarrasParaBusqueda.substring(0, 2);
        if (prefijoCaja === '80') {
          HiNotification.Toast('Se espera una etiqueta de artículo elaborado');
          this.preloader = false;
          await sleep(50);
          this.$refs.UCCodeScannerConRegistros.Open();
          return;
        }
      }

      if ((this.configuracionLecturaCajas.LecturaContinuaCodigosBarras || this.configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual)
        && this.configuracionLecturaRegistroAct?.LecturaContinuaCodigosBarras && this.asignacionRegistroTrabajadores
      ) {
        const objArticuloElborado = {
          IdUnicoCodigoBarras: this.codigoDeBarrasParaBusqueda,
          CodigoBarras: this.codigoDeBarrasParaBusqueda,
          ArticuloRegistro: [],
          Producto: null,
          Envase: null,
          Id: 0,
        };
        let anadido = false;
        this.lstArticulosElaboradosAns.forEach((element) => {
          if (element.CodigoBarras === this.codigoDeBarrasParaBusqueda) {
            anadido = true;
          }
        });
        this.lstArtElaboradosPenSinc.forEach((element) => {
          if (element.CodigoBarras === this.codigoDeBarrasParaBusqueda) {
            anadido = true;
          }
        });
        if (!anadido) {
          this.lstArtElaboradosPenSinc.push(objArticuloElborado);
          objArticuloElborado.sinSincronizar = true;
          this.lstArticulosElaboradosAns.push(objArticuloElborado);
          this.articuloElaboradoSeleccionado = objArticuloElborado;
          await sleep(50);
          this.$refs.UCCodeScannerRegistroActividadContinua.Open();
        } else {
          HiNotification.Toast('Artículo elaborado ya existente');
          await sleep(50);
          this.$refs.UCCodeScannerConRegistros.Open();
        }
        this.$emit('Pendientes-Sinc', this.lstArtElaboradosPenSinc);
      } else {
        const result = await this.Conexion_AsociarArticuloElaboradoConPale(this.objAnsSeleccionado, [this.codigoDeBarrasParaBusqueda]);
        if (!this.asignacionRegistroTrabajadores) { this.lstArticulosElaboradosAns = await this.Conexion_ObtenerArticulosElaboradosXNumeroSerie(this.objAnsSeleccionado); }
        if (result.Valor && this.asignacionRegistroTrabajadores) {
          if (result.Tag.length > 0) {
            let anadido = false;
            this.lstArticulosElaboradosAns.forEach((element) => {
              if (element.Id === result.Tag[0].Id) {
                anadido = true;
              }
            });
            if (!anadido) {
              this.lstArticulosElaboradosAns.push(result.Tag[0]);
            }
            [this.articuloElaboradoSeleccionado] = result.Tag;
            this.$refs.UCCodeScannerRegistroActividadContinua.Open();
          }
        } else if (this.asignacionRegistroTrabajadores) {
          this.$refs.UCCodeScannerConRegistros.Open();
        }
      }
      if (!this.asignacionRegistroTrabajadores) {
        this.preloader = false;
      }
    },

    async EventoLecturaDeCodigoDeBarrasRegistroActividad(codigoBarras) {
      Log(this, this.EventoLecturaDeCodigoDeBarrasRegistroActividad.name);
      const prefijoCaja = codigoBarras.substring(0, 2);
      if (prefijoCaja !== '80') {
        HiNotification.Toast(this.$t('production.info.errorExpectedRegistrationLabel'));
        this.preloader = false;
        await sleep(50);
        this.ComprobarCantidadLecturasRegistros();
        return;
      }
      const codigoActividadPro = codigoBarras.substring(2, 5);
      const codigoTarjeta = codigoBarras.substring(5, 12);
      const codTarjetaSinCeros = codigoTarjeta.replace(/^0+/, '');
      if ((this.configuracionLecturaCajas.LecturaContinuaCodigosBarras || this.configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual)
        && this.configuracionLecturaRegistroAct?.LecturaContinuaCodigosBarras
      ) {
        const registroActividad = {
          Id: 0,
          IdUnicoCodigoBarras: codigoBarras,
          ArticuloElaborado: {
            IdUnicoCodigoBarras: this.articuloElaboradoSeleccionado.CodigoBarras,
            Id: 0,
          },
          ActividadProduccion: {
            Codigo: codigoActividadPro,
          },
          Trabajador: {
            Codigo: codTarjetaSinCeros,
          },
        };
        this.lstArtElaboradosPenSinc[this.lstArtElaboradosPenSinc.length - 1].ArticuloRegistro.push(registroActividad);
        // this.lstArticulosElaboradosAns[this.lstArticulosElaboradosAns.length - 1].ArticuloRegistro.push(registroActividad);

        await sleep(50);
      } else {
        const registroActividad = {
          IdUnicoCodigoBarras: codigoBarras,
          ArticuloElaborado: {
            Id: this.articuloElaboradoSeleccionado.Id,
          },
          ActividadProduccion: {
            Codigo: codigoActividadPro,
          },
          Trabajador: {
            Codigo: codTarjetaSinCeros,
          },

        };
        const result = await this.Conexion_AsociarActividaRegistroArticuloElaborado([registroActividad]);
        if (result.OK.length > 0) {
          this.AddRegistroActividadGuardadosAE(result.OK[0].tag);
        }
      }
      this.ComprobarCantidadLecturasRegistros();
    },

    ComprobarCantidadLecturasRegistros() {
      Log(this, this.ComprobarCantidadLecturasRegistros.name);
      if (this.cantidadLecturasContinuas > 0) {
        this.contadorLecturasContinuas += 1;
        if (this.cantidadLecturasContinuas === this.contadorLecturasContinuas) {
          this.contadorLecturasContinuas = 0;
          if (this.configuracionLecturaCajas.LecturaContinuaCodigosBarras || this.configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual) {
            this.$refs.UCCodeScannerConRegistros.Open();
          }
        } else {
          this.$refs.UCCodeScannerRegistroActividadContinua.Open();
        }
      }
    },
    */

    /**
     * @public
     * @returns {void}
     */
    AddRegistroActividadGuardadosAE(registro) {
      Log(this, this.AddRegistroActividadGuardadosAE.name);
      this.lstArticulosElaboradosAns.forEach((articuloElaborado) => {
        if (registro.ArticuloElaborado.CodigoBarras === articuloElaborado.CodigoBarras) {
          articuloElaborado.ArticuloRegistro.push(registro);
        }
      });
      this.$emit('pendientes-Sinc', this.lstArtElaboradosPenSinc);
    },

    /**
     * @public
     * @param {any} objAns
     * @returns {Promise<void>}
     */
    async PaleEstablecido(objAns) {
      Log(this, this.PaleEstablecido.name);
      this.preloader = true;
      this.objAnsSeleccionado = objAns;
      this.lstArticulosElaboradosAns = await this.Conexion_ObtenerArticulosElaboradosXNumeroSerie(this.objAnsSeleccionado);
      this.preloader = false;
    },

    SolicitarEliminarArticuloElaborado(objArticuloElaborado) {
      Log(this, this.SolicitarEliminarArticuloElaborado.name);
      this.$refs.componenteConfirmacionEliminarPale.create(
        this.$t('production.assignBoxesPallet.deleteElaboratedArticle.title'),
        this.$t('production.assignBoxesPallet.deleteElaboratedArticle.text'),
        () => {
          this.EliminarArticuloElaborado(objArticuloElaborado);
        },
      );
      this.$refs.componenteConfirmacionEliminarPale.show();
    },
    SolicitarEliminarArticuloElaboradoLocal(objArticuloElaborado) {
      Log(this, this.SolicitarEliminarArticuloElaboradoLocal.name);
      this.$refs.componenteConfirmacionEliminarPale.create(
        this.$t('production.assignBoxesPallet.deleteElaboratedArticle.title'),
        this.$t('production.assignBoxesPallet.deleteElaboratedArticle.text'),
        () => {
          this.lstArtElaboradosPenSinc = this.lstArtElaboradosPenSinc.filter((registro) => registro.CodigoBarras !== objArticuloElaborado.CodigoBarras);
          this.lstArticulosElaboradosAns = this.lstArticulosElaboradosAns.filter((registro) => registro.CodigoBarras !== objArticuloElaborado.CodigoBarras);
          this.$emit('pendientes-Sinc', this.lstArtElaboradosPenSinc);
        },
      );
      this.$refs.componenteConfirmacionEliminarPale.show();
    },

    /**
     * @public
     * @returns {void}
     */
    EliminarRegistroLocal(registroLocal) {
      Log(this, this.EliminarRegistroLocal.name);

      const eliminarRegistro = (lista) => {
        lista.forEach((element) => {
          if (element.CodigoBarras === registroLocal.ArticuloElaborado.CodigoBarras) {
            element.ArticuloRegistro = element.ArticuloRegistro.filter((registro) => registroLocal.IdUnicoCodigoBarras !== registro.IdUnicoCodigoBarras);
          }
        });
      };
      eliminarRegistro(this.lstArtElaboradosPenSinc);
      eliminarRegistro(this.lstArticulosElaboradosAns);

      this.lstArtElaboradosPenSinc = this.lstArticulosElaboradosAns.filter(
        (articuloElaborado) => articuloElaborado.Id === 0
          || articuloElaborado.ArticuloRegistro.some((registro) => registro.Id === 0),
      );
      this.$emit('pendientes-Sinc', this.lstArtElaboradosPenSinc);
    },
    /** * Método EditarRegistroActividadArticuloElaborado */
    EditarRegistroActividadArticuloElaborado(objArticuloElaborado) {
      Log(this, this.EditarRegistroActividadArticuloElaborado.name);
      const objAE = { ...objArticuloElaborado };
      this.$emit('editarActividadEnvase', objAE);
    },
    ErrorRegistro(articulo) {
      Log(this, this.ErrorRegistro.name);
      let hayError = false;
      articulo.ArticuloRegistro.forEach((element) => {
        if (element.Id === 0) {
          hayError = true;
        }
      });

      return hayError;
    },
    /** * Método EliminarArticuloElaborado */
    async EliminarArticuloElaborado(objArticuloElaborado) {
      Log(this, this.EliminarArticuloElaborado.name);
      this.preloader = true;
      this.lstArticulosElaboradosAns = [];
      await this.Conexion_EliminarAsociacionArticuloElaboradoConPale(objArticuloElaborado.CodigoBarras);
      this.lstArticulosElaboradosAns = await this.Conexion_ObtenerArticulosElaboradosXNumeroSerie(this.objAnsSeleccionado);
      this.preloader = false;
    },
    AbrirScannerLecturaCajas() {
      Log(this, this.AbrirScannerLecturaCajas.name);
      if (!this.asignacionRegistroTrabajadores) {
        this.$refs.UCCodeScanner.Open();
      } else {
        this.$refs.UCCodeScannerConRegistros.Open();
      }
    },

    /** ***************************** TODO JUAN MIRANDA ELIMINAR ANTERIOES */
    /** ***************************** TODO JUAN MIRANDA ELIMINAR ANTERIOES */
    /** ***************************** TODO JUAN MIRANDA ELIMINAR ANTERIOES */
    /** ***************************** TODO JUAN MIRANDA ELIMINAR ANTERIOES */

    /** * Método EventoLecturaDeCodigoDeBarrasCaja */
    async EventoLecturaDeCodigoDeBarrasCaja_NEW(codigoBarras) {
      Log(this, this.EventoLecturaDeCodigoDeBarrasCaja_NEW.name);
      if (!this.asignacionRegistroTrabajadores) {
        this.lstArticulosElaboradosAns = [];
      }
      if (!this.asignacionRegistroTrabajadores) {
        this.preloader = true;
      }
      this.codigoDeBarrasParaBusqueda = codigoBarras;
      if (this.comprobarConfeccionCaja
      && this.comprobarConfeccionCajaEnMovilidad
      && this.pedidoSeleccionado.Confeccion
      && !codigoBarras.includes(this.pedidoSeleccionado.Confeccion.Codigo)) {
        this.$refs.componentPCLectorArticuloElaboradoYActividad.reset();
        HiNotification.Toast(this.$t('production.assignBoxesPallet.invalidAssemblyToastText'));
        return;
      }
      if (codigoBarras.length > 13) {
        // Obtener los últimos 20 dígitos
        const ultimos20Digitos = codigoBarras.slice(-20);
        this.codigoDeBarrasParaBusqueda = ultimos20Digitos;
      }
      /*
      if (this.asignacionRegistroTrabajadores) {
        const prefijoCaja = this.codigoDeBarrasParaBusqueda.substring(0, 2);
        if (prefijoCaja === '80') {
          HiNotification.Toast('Se espera una etiqueta de artículo elaborado');
          this.preloader = false;
          await sleep(50);
          // this.$refs.UCCodeScannerConRegistros.Open();
          return;
        }
      }
      */

      if ((this.configuracionLecturaCajas.LecturaContinuaCodigosBarras || this.configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual) && this.configuracionLecturaRegistroAct.LecturaContinuaCodigosBarras && this.asignacionRegistroTrabajadores) {
        const objArticuloElborado = {
          IdUnicoCodigoBarras: this.codigoDeBarrasParaBusqueda,
          CodigoBarras: this.codigoDeBarrasParaBusqueda,
          ArticuloRegistro: [],
          Producto: null,
          Envase: null,
          Id: 0,
        };
        let anadido = false;
        let existingItem = null;
        this.lstArticulosElaboradosAns.forEach((element) => {
          if (element.CodigoBarras === this.codigoDeBarrasParaBusqueda) {
            anadido = true;
            existingItem = element;
          }
        });
        this.lstArtElaboradosPenSinc.forEach((element) => {
          if (element.CodigoBarras === this.codigoDeBarrasParaBusqueda) {
            anadido = true;
            existingItem = element;
          }
        });
        if (!anadido) {
          this.lstArtElaboradosPenSinc.push(objArticuloElborado);
          objArticuloElborado.sinSincronizar = true;
          this.lstArticulosElaboradosAns.push(objArticuloElborado);
          this.articuloElaboradoSeleccionado = objArticuloElborado;
        } else {
          const indexdelete = this.lstArticulosElaboradosAns.findIndex((item) => item.CodigoBarras === this.codigoDeBarrasParaBusqueda);
          this.lstArticulosElaboradosAns.splice(indexdelete, 1);
          objArticuloElborado.Id = existingItem.Id;
          this.lstArtElaboradosPenSinc.push(objArticuloElborado);
          this.lstArticulosElaboradosAns.push(objArticuloElborado);
          objArticuloElborado.sinSincronizar = true;
          this.articuloElaboradoSeleccionado = objArticuloElborado;
          this.moveItemToTop(this.codigoDeBarrasParaBusqueda);
          notifyReadingError(this.$t('production.assignBoxesPallet.elaboratedArticleAlreadyExistsToastText'));
          await this.deleteRecordsByBox(existingItem);
        }
        this.$emit('pendientes-Sinc', this.lstArtElaboradosPenSinc);
      } else {
        let anadido = false;
        let existingItem = null;
        /* let anadido = false;
        let existingItem = null;
        this.lstArticulosElaboradosAns.forEach((element) => {
          if (String(element.IdUnicoCodigoBarras) === String(this.codigoDeBarrasParaBusqueda)) {
            anadido = true;
            existingItem = element;
          }
        });
        if (anadido) {
          this.moveItemToTop(this.codigoDeBarrasParaBusqueda);
          HiNotification.Toast(this.$t('production.assignBoxesPallet.elaboratedArticleAlreadyExistsToastText'));
          await this.deleteRecordsByBox(existingItem);
        } */
        const result = await this.Conexion_AsociarArticuloElaboradoConPale(this.objAnsSeleccionado, [this.codigoDeBarrasParaBusqueda]);
        if (!this.asignacionRegistroTrabajadores) {
          this.lstArticulosElaboradosAns = await this.Conexion_ObtenerArticulosElaboradosXNumeroSerie(this.objAnsSeleccionado);
        }
        if (result.Valor && this.asignacionRegistroTrabajadores) {
          if (result.Tag.length > 0) {
            this.lstArticulosElaboradosAns.forEach((element) => {
              if (element.Id === result.Tag[0].Id) {
                anadido = true;
                existingItem = element;
              }
            });
            if (!anadido) {
              this.lstArticulosElaboradosAns.push(result.Tag[0]);
            } else {
              this.moveItemToTop(this.codigoDeBarrasParaBusqueda);
              notifyReadingError(this.$t('production.assignBoxesPallet.elaboratedArticleAlreadyExistsToastText'));
              await this.deleteRecordsByBox(existingItem);
            }
            [this.articuloElaboradoSeleccionado] = result.Tag;
          }
        }
      }
      if (!this.asignacionRegistroTrabajadores) {
        this.preloader = false;
      }
    },
    moveItemToTop(codigoDeBarrasParaBusqueda) {
      Log(this, this.moveItemToTop.name);
      const indexMove = this.lstArticulosElaboradosAns.findIndex((ae) => String(ae.IdUnicoCodigoBarras) === String(codigoDeBarrasParaBusqueda));
      if (indexMove > -1) {
        const [aeRemoved] = this.lstArticulosElaboradosAns.splice(indexMove, 1);
        this.lstArticulosElaboradosAns.push(aeRemoved);
      }
    },
    async deleteRecordsByBox(elaboratedItem) {
      Log(this, this.deleteRecordsByBox.name);
      HiDialog.Preloader(true, this.$t('production.assignBoxesPallet.deleteRegister'));
      if (elaboratedItem.Id !== 0) {
        const resisters = await this.Conexion_ObtenerRegistroActividades(elaboratedItem.Id);
        for await (const register of resisters) {
          await this.Conexion_EliminarRegistroActividadArticuloElaborado(register.Id);
        }
      }
      this.lstArtElaboradosPenSinc.forEach((articuloE) => {
        if (articuloE.IdUnicoCodigoBarras === elaboratedItem.IdUnicoCodigoBarras) {
          articuloE.ArticuloRegistro = [];
        }
      });
      HiDialog.Preloader(false);
    },

    /** * Método EventoLecturaDeCodigoDeBarrasRegistroActividad */
    async EventoLecturaDeCodigoDeBarrasRegistroActividad_NEW(codigoBarras) {
      Log(this, this.EventoLecturaDeCodigoDeBarrasRegistroActividad_NEW.name);
      const codigoActividadPro = codigoBarras.substring(2, 5);
      const codigoTarjeta = codigoBarras.substring(5, 12);
      const codTarjetaSinCeros = codigoTarjeta.replace(/^0+/, '');
      if ((this.configuracionLecturaCajas.LecturaContinuaCodigosBarras || this.configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual) && this.configuracionLecturaRegistroAct.LecturaContinuaCodigosBarras) {
        let exists = false;
        let numberRecords = 0;
        this.lstArtElaboradosPenSinc.forEach((articuloE) => {
          if (articuloE.IdUnicoCodigoBarras === this.articuloElaboradoSeleccionado.IdUnicoCodigoBarras) {
            numberRecords = this.cantidadLecturasContinuas - (articuloE.ArticuloRegistro?.length ?? 0);
            articuloE.ArticuloRegistro.forEach((registro) => {
              if (registro.IdUnicoCodigoBarras === codigoBarras) {
                exists = true;
              }
            });
          }
        });
        if (exists) {
          notifyReadingError(this.$t('production.assignBoxesPallet.workerLogExist'));
          if (numberRecords > 0) {
            this.$refs.componentPCLectorArticuloElaboradoYActividad.setActivityRegister(this.articuloElaboradoSeleccionado.IdUnicoCodigoBarras, numberRecords);
          } else {
            this.$refs.componentPCLectorArticuloElaboradoYActividad.reset();
          }
          return;
        }
        const registroActividad = {
          Id: 0,
          IdUnicoCodigoBarras: codigoBarras,
          ArticuloElaborado: {
            IdUnicoCodigoBarras: this.articuloElaboradoSeleccionado.IdUnicoCodigoBarras,
            Id: 0,
          },
          ActividadProduccion: {
            Codigo: codigoActividadPro,
          },
          Trabajador: {
            Codigo: codTarjetaSinCeros,
          },
        };
        this.lstArtElaboradosPenSinc[this.lstArtElaboradosPenSinc.length - 1].ArticuloRegistro.push(registroActividad);
        await sleep(100);
      } else {
        this.lstRegistrosActividad = await this.Conexion_ObtenerRegistroActividades(this.articuloElaboradoSeleccionado.Id);
        let exists = false;
        const numberRecords = this.cantidadLecturasContinuas - (this.lstRegistrosActividad?.length ?? 0);
        this.lstRegistrosActividad?.forEach((registro) => {
          if (registro.IdUnicoCodigoBarras === codigoBarras) exists = true;
        });
        if (exists) {
          notifyReadingError(this.$t('production.assignBoxesPallet.workerLogExist'));
          if (numberRecords > 0) {
            this.$refs.componentPCLectorArticuloElaboradoYActividad.setActivityRegister(this.articuloElaboradoSeleccionado.IdUnicoCodigoBarras, numberRecords);
          } else {
            this.$refs.componentPCLectorArticuloElaboradoYActividad.reset();
          }
          return;
        }
        const registroActividad = {
          IdUnicoCodigoBarras: codigoBarras,
          ArticuloElaborado: {
            Id: this.articuloElaboradoSeleccionado.Id,
          },
          ActividadProduccion: {
            Codigo: codigoActividadPro,
          },
          Trabajador: {
            Codigo: codTarjetaSinCeros,
          },
        };
        const result = await this.Conexion_AsociarActividaRegistroArticuloElaborado([registroActividad]);
        if (result.OK.length > 0) {
          this.AddRegistroActividadGuardadosAE(result.OK[0].tag);
        }
      }
    },

    async Conexion_ObtenerArticulosElaboradosXNumeroSerie(objAns) {
      Log(this, this.Conexion_ObtenerArticulosElaboradosXNumeroSerie.name);
      try {
        const result = await ConexionTA.callObtenerArticulosElaboradosXNumeroSerie(objAns.Id);
        if (result.Valor) {
          return JSON.parse(result.Mensaje);
        }
        HiNotification.Alert(result.Mensaje, this.$t('common.error'));
      } catch {
        HiNotification.Toast(this.$t('common.checkYourConnection'));
      }
      return [];
    },

    async Conexion_AsociarArticuloElaboradoConPale(objAns, lstCodigosArticuloElaborado) {
      Log(this, this.Conexion_AsociarArticuloElaboradoConPale.name);
      try {
        const result = await ConexionTA.callAsociarArticuloElaboradoConPale(objAns.Id, false, JSON.stringify(lstCodigosArticuloElaborado));
        if (result.Valor) {
          return result;
        }
        notifyReadingError(result.Mensaje);
      } catch {
        notifyReadingError(this.$t('common.checkYourConnection'));
        return false;
      }
      return false;
    },

    async Conexion_AsociarActividadesRegistrosArticulosElaborados(objAns, lstArticulosElaborado) {
      Log(this, this.Conexion_AsociarActividadesRegistrosArticulosElaborados.name);
      try {
        const result = await ConexionTA.callGuardarArticulosElaboradosRegistrosActividad(objAns.Id, lstArticulosElaborado);
        if (result.Valor) {
          result.Tag.ERROR_AE.forEach((element) => {
            HiNotification.Toast(`${element.mensaje} : ${element.tag.CodigoBarras}`);
          });
          result.Tag.ERROR_RA.forEach((element) => {
            HiNotification.Toast(`${element.mensaje} : ${element.tag.IdUnicoCodigoBarras}`);
          });
          return result.Tag;
        }
        HiNotification.Toast(result.Mensaje);
        return { errorSinTag: true };
      } catch {
        // return false;
        HiNotification.Toast(this.$t('common.checkYourConnection'));
        return { errorSinTag: true };
      }
    },
    async Conexion_AsociarActividaRegistroArticuloElaborado(lstRegistrosActividad) {
      Log(this, this.Conexion_AsociarActividaRegistroArticuloElaborado.name);
      try {
        const result = await ConexionTA.callGuardarArticuloElaboradoRegistroActividad(lstRegistrosActividad);
        if (result.Valor) {
          result.Tag.ERROR.forEach((element) => {
            HiNotification.Toast(`${element.mensaje} : ${element.tag.IdUnicoCodigoBarras}`);
          });

          if (result.Tag.ERROR.length > 0) {
            notifyReadingError();
          }

          return result.Tag;
        }

        notifyReadingError();
        return false;
      } catch {
        // return false;
        notifyReadingError(this.$t('common.checkYourConnection'));
        return false;
      }
    },

    async Conexion_EliminarAsociacionArticuloElaboradoConPale(codigoArticuloElaborado) {
      Log(this, this.Conexion_EliminarAsociacionArticuloElaboradoConPale.name);
      try {
        const result = await ConexionTA.callEliminarAsociacionArticuloElaboradoConPale(codigoArticuloElaborado);
        if (result.Valor) {
          return true;
        }
        HiNotification.Alert(result.Mensaje, this.$t('common.error'));
      } catch {
        HiNotification.Toast(this.$t('common.checkYourConnection'));
      }
      return false;
    },
    async Conexion_ObtenerRegistroActividades(idArt) {
      Log(this, this.Conexion_ObtenerRegistroActividades.name);
      try {
        const result = await callExecuteSPERP(
          'APPERPAGRO_RegistrosActividadXArticuloElaborado',
          [
            { NombreParametro: 'idArtElaborado', Valor: idArt },
          ],
          'Trazabilidad.ArticuloElaboradoRegistroActividadJSON',
        );
        if (result.statusText === 'OK') {
          return result.data;
        }
        return [];
      } catch {
        return [];
      }
    },
    /** * Método Conexion_EliminarRegistroActividadArticuloElaborado */
    async Conexion_EliminarRegistroActividadArticuloElaborado(idRegistroActividad) {
      Log(this, this.Conexion_EliminarRegistroActividadArticuloElaborado.name);
      try {
        const result = await ConexionTA.callEliminarRegistroActividadArticuloElaborado(idRegistroActividad);
        if (result.Valor) {
          return true;
        }
        HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        return false;
      } catch {
        return false;
      }
    },

  },
};
</script>

<style scoped lang="scss">
.main-PCLecturaEnvasesPale {
  .btn-base-gris-1 {
    width: 48px;
    height: 48px;
    min-height: 48px;
    min-width: 48px;
  }

  /* Permite que el boton flotante de Confirmar  este flotante sin desplazamiento */
  .md .fab[class*="-bottom"] {
    position: fixed;
  }

  .div-cabeceraTituloCajasAsociadas {
    color: #24253d;
    text-transform: none;
    font-size: 22px;
    background: var(--his-tierra-white);
    padding-left: 25px;
    border-bottom: 4px;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-color: var(--his-disabled);
    border-style: solid;
  }

  .div-registroPale {
    padding: 10px;
    padding-left: 25px;
    border-bottom: 1px;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-color: var(--his-disabled);
    border-style: solid;
  }

  .div-listado {
    max-height: 100%;
    overflow-y: auto;
    height: calc(100vh - 228px);

    @media (min-width: 630px) {
      height: calc(var(--f7-popup-tablet-height) - 250px);
    }
  }

  .buton-guardado {
    display: flex;
    flex-direction: row-reverse;
    margin-right: 50px;
    margin-top: 20px;
  }
}
</style>
